<section id="CallsPage">
   <div
      class="spinner"
      *ngIf="isLoading">
      <div
         class="spinner-border"
         role="status">
         <span class="sr-only">Loading...</span>
      </div>
   </div>
   <div
      class="container"
      *ngIf="!isLoading">
      <div
         class="row pt-3"
         *ngIf="!callLog && selectedCampaign">
         <div class="alert alert-info w-100">There are no more calls for {{ selectedCampaignName }}.</div>
      </div>
      <div class="row">
         <div class="col-12 pt-3 d-flex justify-content-between">
            <div>
               <div
                  class="alert alert-primary mr-3"
                  style="display: inline-block; padding: 0.45rem 1.05rem; background-color: #ffffff8f; color: #00a876; border-color: #ffffff8f"
                  role="alert">
                  <app-campaign-item [campaign]="selectedCampaign"></app-campaign-item>
                  <p
                     style="margin-bottom: 0"
                     *ngIf="selectedCampaign?.practiceName">
                     {{ selectedCampaign.practiceName }}
                  </p>
               </div>
               <button
                  class="v-button v-button-md v-green"
                  (click)="selectNewCampaign()"
                  style="vertical-align: super">
                  Select
               </button>
            </div>
            <vc-dropdown-button
               class="ml-auto"
               defaultLabel="Text Dispositions"
               [items]="textDispositions()"
               idSelector="id"
               textSelector="description"
               [selectedItemId]="callLog?.dispositionId"
               (itemSelected)="onSetDisposition($event)"></vc-dropdown-button>
            <vc-dropdown-button
               defaultLabel="Phone Dispositions"
               [items]="callDispositions()"
               idSelector="id"
               textSelector="description"
               [selectedItemId]="callLog?.dispositionId"
               (itemSelected)="onSetDisposition($event)"></vc-dropdown-button>

            <button
               class="v-button v-button-md v-green"
               [disabled]="!callLog?.dispositionId"
               style="height: 38px; vertical-align: bottom"
               (click)="onNext()">
               Next
            </button>
         </div>
      </div>
      <div
         class="row pt-3"
         *ngIf="callLog">
         <div class="col-md-6 d-flex">
            <div
               class="card mb-5"
               style="width: 100%">
               <div class="box-heading">
                  <h4 class="card-header">Client Details</h4>
               </div>
               <div class="card-body">
                  <table class="table table-borderless">
                     <tbody>
                        <tr>
                           <th scope="row">ID:</th>
                           <td>{{ client.pimsId }}</td>
                        </tr>
                        <tr>
                           <th scope="row">Name:</th>
                           <td>{{ client.fullName }}</td>
                        </tr>
                        <tr>
                           <th scope="row">Address:</th>
                           <td>{{ client.fullAddress }}</td>
                        </tr>
                     </tbody>
                  </table>
               </div>
            </div>
         </div>

         <div class="col-md-6 mb-5 d-flex">
            <div
               class="card"
               style="width: 100%">
               <div class="box-heading">
                  <h4 class="card-header">Phone Numbers</h4>
               </div>
               <div class="card-body">
                  <table class="table table-hover">
                     <thead>
                        <tr>
                           <th scope="col">Phone</th>
                           <th></th>
                           <!-- <th scope="col">Call Status</th>  -->
                        </tr>
                     </thead>
                     <tbody>
                        <tr *ngFor="let phone of phoneNumbers">
                           <th>{{ phone.type }}:</th>
                           <td id="Phone">{{ phone.number | phone : "US" }}</td>
                           <!-- <td>Ongoing</td>  -->
                        </tr>
                     </tbody>
                  </table>
               </div>
            </div>
         </div>

         <div
            class="col-12 m-auto"
            *ngIf="(callHistory || []).length > 0">
            <div class="card">
               <div class="box-heading">
                  <h4 class="card-header">Call History</h4>
               </div>
               <div class="card-body">
                  <table class="table">
                     <thead>
                        <tr>
                           <th scope="col">Caller</th>
                           <th scope="col">Call Time</th>
                           <th scope="col">Disposition</th>
                        </tr>
                     </thead>
                     <tbody>
                        <ng-container *ngFor="let item of callHistory">
                           <tr>
                              <td>{{ item.callerName }}</td>
                              <td>{{ item.callTime | date : "medium" }}</td>
                              <td>{{ item.disposition }}</td>
                           </tr>
                        </ng-container>
                     </tbody>
                  </table>
               </div>
            </div>
         </div>

         <div class="col-12 m-auto">
            <div class="card">
               <div class="box-heading">
                  <h4 class="card-header">Patient Info</h4>
               </div>
               <div class="card-body">
                  <table class="table">
                     <thead>
                        <tr>
                           <th scope="col">Pet Name</th>
                           <th scope="col">Species</th>
                           <th scope="col">Breed</th>
                           <th scope="col">Sex</th>
                           <th scope="col">Age</th>
                           <th scope="col">Last Appt / Next Appt</th>
                           <th scope="col">Reminders</th>
                        </tr>
                     </thead>
                     <tbody>
                        @for (pat of client.patients; track pat; let idx = $index) {
                        <tr [ngClass]="{ 'highlight-patient': hasNextAppointment(pat) }">
                           <td>{{ pat.name }}</td>
                           <td>{{ pat.species }}</td>
                           <td>{{ pat.breed }}</td>
                           <td>{{ pat.sex }}</td>
                           <td>
                              {{ today | amDifference : pat.birthdate : "years" : false }}
                              years ({{ pat.birthdate | date }})
                           </td>
                           <td>
                              {{ pat.lastAppointment ? (pat.lastAppointment | date) : "N/A" }} /
                              <span class="next-appt-date">
                                 {{ pat.nextAppointment ? (pat.nextAppointment | date) : "N/A" }}
                              </span>
                           </td>
                           <td class="paw-favicon">
                              <i
                                 *ngIf="pat.reminders.length"
                                 class="fa fa-paw"
                                 [ngClass]="{
                                    'paw-reminder-alert': hasRemindersOnAlert(pat, true),
                                    'paw-reminder-warning': hasRemindersOnAlert(pat, false)
                                 }"
                                 [pTooltip]="popoverTemplate"
                                 tooltipPosition="left"
                                 [autoHide]="false"
                                 tooltipStyleClass="calls-tooltip"
                                 positionLeft="-0"
                                 triggers="mouseenter:mouseleave"
                                 popoverTitle="Reminders"
                                 container="body"></i>
                           </td>
                           <ng-template #popoverTemplate>
                              <ul class="calls-tooltip-list">
                                 <li
                                    *ngFor="let r of pat.reminders"
                                    [ngClass]="{ 'reminder-alert': isReminderOnAlert(r, true), 'reminder-warning': isReminderOnAlert(r, false) }">
                                    {{ r.reminderTypeDescription }}
                                    ({{ r.pastDueDate | date }})
                                 </li>
                              </ul>
                           </ng-template>
                        </tr>
                        }
                        <tr></tr>
                        <tr></tr>
                     </tbody>
                  </table>
               </div>
            </div>
         </div>
         <div class="col-12 m-auto">
            <div class="card">
               <div class="box-heading">
                  <h4 class="card-header">Notes</h4>
               </div>
               <div class="card-body">
                  <textarea
                     type="text"
                     pInputText
                     inputId="notes"
                     class="w-100"
                     [style]="{ width: '100%' }"
                     [(ngModel)]="callNotes"
                     rows="4"></textarea>
               </div>
            </div>
         </div>
         <div class="col-12 m-auto">
            <div class="primary-practice">
               <em>Current Hospital: {{ client.primaryPractice }}</em>
            </div>
         </div>
      </div>
   </div>
</section>
